import { useEffect } from "react";
import "./assets/css/Style.css";
import "./assets/css/Form-element.css";
import imgdelete from "./assets/img/delete.png";
import logoblue from "./assets/img/questmath-logo-blue.png";

export default function Otp() {
  useEffect(() => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    console.log("Height: " + vh);
  }, []);

  return (
    <>
      <div className="main-container shortDistance bgchange">
        <div className="inner-container left-container left-bg ">
          <div className="curve-container">
            <div className="register-container">
              <div className="register-steps">
                <div></div>
                <div className="selected"></div>
                <div></div>
              </div>
              <div className="register-titles">
                <div className="register-title">Please verify OTP</div>
                <div className="register-sub-title">
                  An OTP has been sent to your phone and email
                </div>
              </div>
              <div className="form-row-custom">
                <label className="custom-label">Enter OTP</label>
                <div className="otp-container">
                  <input
                    type="text"
                    className="custom-field filled"
                    placeholder="0"
                    value="2"
                  />
                  <input
                    type="text"
                    className="custom-field custom-error"
                    placeholder="0"
                  />
                  <input type="text" className="custom-field" placeholder="0" />
                  <input type="text" className="custom-field" placeholder="0" />
                </div>
                <span>OTP entered is incorrect</span>
              </div>
              <div className="form-row-custom">
                <div className="resend-text">Resend OTP in 00:20 sec</div>
              </div>

              <div className="form-row-custom register-form-btn mb-0">
                <button
                  className="quest-btn quest-primary-btn"
                  onclick="window.location.href='registrationslot.html'"
                >
                  Verify
                </button>
                <div className="custom-link">
                  <a href="#">Resend OTP</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="inner-container right-container right-bg">
          <div className="register-right-container">
            <div className="register-right-titles">
              <div className="register-right-sub-title">Welcome to </div>
              <div className="register-right-title">
                <img
                  src={logoblue}
                  className="img-fluid"
                  alt="QuestMath Blue Logo"
                />
              </div>
            </div>
            <div className="register-features-container hideinsmallscreen">
              <div className="register-features-row">
                <div className="feature-card">
                  <div className="feature-title">
                    INDIVIDUAL ATTENTION
                    <br />
                    <span>1 : 1 className with mentor</span>
                  </div>
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                </div>
              </div>
              <div className="register-features-row card-right">
                <div className="feature-card">
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                  <div className="feature-title">
                    EXCLUSIVE WORKOUTS
                    <br />
                    <span>Practice workoouts for free</span>
                  </div>
                </div>
              </div>
              <div className="register-features-row">
                <div className="feature-card">
                  <div className="feature-title">
                    UNLOCK REWARDS
                    <br />
                    <span>Earn rewards while learning</span>
                  </div>
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
